import {Link} from "react-router-dom";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import BgPattern from "../../../images/BG-Pattern.png";
import NoProfile from "../../../images/profileImage.png";
import {userRoleList} from "../../../utils/constants";
import TableFacture from "./tableFactures";
import QueryErrorState from "../../components/shared/QueryErrorState";

const FactureListPageClient = () => {
  const {data, isLoading, isError, error, refetch} = useMe();
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <>
      <div className="w-full  lg:grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit bg-white rounded-2xl hidden lg:block sticky top-[90px]  ">
          <div
            className="w-full h-[84px] bg-cover bg-center rounded-t-xl relative "
            style={{backgroundImage: `url('${BgPattern}')`}}
          >
            <div className="absolute -bottom-12 rounded-md left-[50%] -translate-x-[50%]">
              <div className="relative">
                {!!data?.avgRating && (
                  <Link
                    to={"/mon-profil/#avis"}
                    className="bg-[#FFC107] w-1/2 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[12px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                  >
                    {Number(data?.avgRating).toFixed(2)}
                    <StarIcon className="fill-white stroke-none w-3 h-3" />
                  </Link>
                )}
                {/* <div className="absolute w-6 h-6 bg-white flex justify-center items-center top-1 right-1 text-[#1A64B9] rounded-full">
                  <img className="w-4" src={Crown} alt="" title="Professionnel" />{" "}
                </div> */}
                <ImageComponent
                  src={buildImageUrl(data?.imageUri)}
                  alt=""
                  className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                  fallback={
                    <img
                      src={NoProfile}
                      alt=""
                      className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                      width="130"
                    />
                  }
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-14">
            <Link
              to={"/mon-profil"}
              className="text-center text-[#19295C] font-semibold capitalize "
            >
              {`${data.lastName}  ${data.firstName}`}
            </Link>
            <div className="text-center text-primary font-normal text-sm">
              {data.selectedRole === userRoleList.TECHNICIAN
                ? "Prestataire"
                : "Client"}
            </div>
            <Link
              to={"/mon-profil#avis"}
              className="text-right lg:text-center flex-grow  lg:flex-grow-0 text-xs font-normal lg:mt-3  underline text-[#7E7E7E] "
            >
              {data?.reviews?.length ?? 0} évaluation(s)
            </Link>
            <Link
              to="/deposer-une-annonce"
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] border-t border-b border-solid border-[#D6E2EF] px-4 py-3 group hover:text-[#FF6600] mt-3 "
            >
              <i className="fi fi-rr-multiple flex items-center"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                Créer une annonce
              </span>
            </Link>
            <Link
              to={"/mon-profil"}
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] group hover:text-[#FF6600] px-4 py-3 "
            >
              <i className="fi fi-rr-user flex justify-center items-center group-hover:text-[#FF6600]"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600]  ">
                Mon profil
              </span>
            </Link>
          </div>
        </div>
        <div className="w-full col-span-3 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          <div className="text-[#19295C] font-bold text-base w-full text-left sm:text-lg 2xl:text-xl">
            Mes factures
          </div>
          <div className="w-full flex flex-col gap-4">
            <TableFacture />
          </div>
        </div>
      </div>
    </>
  );
};
export default FactureListPageClient;
